import axios from "axios";
import {toast} from "react-toastify";
import assign from "lodash/assign";
import get from "lodash/get";
import i18next from 'i18next';

import {store} from "../configureStore";
import {
    loadChatByIdRequestFail,
    loadChatByIdRequestStart,
    loadChatByIdRequestSuccess,

    updateChatRequestStart,
    updateChatRequestSuccess,
    updateChatRequestFail,

    loadGroupByIdRequestFail,
    loadGroupByIdRequestStart,
    loadGroupByIdRequestSuccess,

    loadChannelByIdRequestFail,
    loadChannelByIdRequestStart,
    loadChannelByIdRequestSuccess,

    loadGroupSchemaByIdRequestFail,
    loadGroupSchemaByIdRequestStart,
    loadGroupSchemaByIdRequestSuccess,

    loadChannelSchemaByIdRequestFail,
    loadChannelSchemaByIdRequestStart,
    loadChannelSchemaByIdRequestSuccess,

    loadChatsRequestFail,
    loadChatsRequestStart,
    loadChatsRequestSuccess,

    loadMessagesRequestFail,
    loadMessagesRequestStart,
    loadMessagesRequestSuccess,

    sendMessageRequestFail,
    sendMessageRequestStart,
    sendMessageRequestSuccess,

    updateReadTime,

    importNewContactsRequestSuccess,
    importNewContactsRequestFail,
    importNewContactsToggleModal, addingNewContactRequestSuccess, addingNewContactRequestFail, setActiveChatChatWindow,
} from '../actions/Chats'
import {catchError, map} from "rxjs/operators";
import {of} from "rxjs";


export const loadChatById = (chatId, callback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,

            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });
        dispatch(updateReadTime(chatId));
        dispatch(loadChatByIdRequestStart(chatId));

        instance.get(`bot/chats/${chatId}/`).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(loadChatByIdRequestSuccess(response.data.result));
                    instance.get(`bot/chats/${chatId}/get_chat_window/`).then(windowResponse=>{
                        if (windowResponse.data.status === 'ok') {
                            dispatch(setActiveChatChatWindow(windowResponse.data.result));
                        }
                    })
                    callback && callback(response.data.result);
                } else {
                    dispatch(loadChatByIdRequestFail(response.data.errors));
                }
            },
            error => dispatch(loadChatByIdRequestFail(`Errors: ${get(error, 'response.data.errors')}`)),
        );
    }
};


export const loadGroupById = (chatId, callback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,

            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        dispatch(loadGroupByIdRequestStart(chatId));

        instance.get(`bot/groups/${chatId}/`).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(loadGroupByIdRequestSuccess(response.data.result));
                    callback && callback(response.data.result);
                } else {
                    dispatch(loadGroupByIdRequestFail(response.data.errors));
                }
            },
            error => dispatch(loadGroupByIdRequestFail(`Errors: ${get(error, 'response.data.errors')}`)),
        );
    }
};


export const loadChannelById = (chatId, callback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,

            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        dispatch(loadChannelByIdRequestStart(chatId));

        instance.get(`bot/channels/${chatId}/`).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(loadChannelByIdRequestSuccess(response.data.result));
                    callback && callback(response.data.result);
                } else {
                    dispatch(loadChannelByIdRequestFail(response.data.errors));
                }
            },
            error => dispatch(loadChannelByIdRequestFail(`Errors: ${get(error, 'response.data.errors')}`)),
        );
    }
};


export const loadGroupSchemaById = (chatId, successCallback, errorCallback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,

            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        dispatch(loadGroupSchemaByIdRequestStart(chatId));

        let data = {
            shop_id: store.getState().Shops.activeShop.id,
        };
        instance.get(`bot/groups/${chatId}/form_schema/`, {params: data}).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(loadGroupSchemaByIdRequestSuccess(response.data.result));
                    successCallback && successCallback(response.data.result);
                } else {
                    dispatch(loadGroupSchemaByIdRequestFail(response.data.errors));
                    errorCallback && errorCallback(response.data.errors);
                }
            },
            error => {
                dispatch(loadGroupSchemaByIdRequestFail(error));
                errorCallback && errorCallback(error);
            },
        );
    }
};


export const loadChannelSchemaById = (chatId, successCallback, errorCallback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,

            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        dispatch(loadChannelSchemaByIdRequestStart(chatId));

        let data = {
            shop_id: store.getState().Shops.activeShop.id,
        };
        instance.get(`bot/channels/${chatId}/form_schema/`, {params: data}).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(loadChannelSchemaByIdRequestSuccess(response.data.result));
                    successCallback && successCallback(response.data.result);
                } else {
                    dispatch(loadChannelSchemaByIdRequestFail(response.data.errors));
                    errorCallback && errorCallback(response.data.errors);
                }
            },
            error => {
                dispatch(loadChannelSchemaByIdRequestFail(error));
                errorCallback && errorCallback(error);
            },
        );
    }
};


export const updateChat = (chatId, data, callback, successMessage) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,

            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        dispatch(updateChatRequestStart(chatId, data));

        instance.patch(`bot/chats/${chatId}/`, data).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(updateChatRequestSuccess(chatId, response.data.result));
                    toast.success(successMessage);
                    callback && callback(response.data.result);
                } else {
                    dispatch(updateChatRequestFail(chatId, response.data.errors));
                }
            },
            error => dispatch(updateChatRequestFail(chatId, error)),
        );
    }
};


export const loadChats = (filters, callback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,

            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        let data = assign(
            filters,
            {
                shop_id: store.getState().Shops.activeShop.id,
            }
        );

        dispatch(loadChatsRequestStart(data));

        instance.get('bot/chats/', {params: data}).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(loadChatsRequestSuccess(response.data.result));
                    callback && callback(response.data.result);
                } else {
                    dispatch(loadChatsRequestFail(response.data.errors));
                }
            },
            error => dispatch(loadChatsRequestFail(`Errors: ${get(error, 'response.data.errors')}`)),
        );
    };
};


export const loadMessages = (filters, successCallback, errorCallback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,

            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        let data = assign(
            filters,
            {
                shop_id: store.getState().Shops.activeShop.id,
            }
        );

        dispatch(loadMessagesRequestStart(data));

        instance.get('bot/messages/', {params: data}).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(loadMessagesRequestSuccess(response.data.result));
                    successCallback && successCallback(response.data.result);
                } else {
                    dispatch(loadMessagesRequestFail(response.data.errors));
                    errorCallback && errorCallback(response.data.errors);
                }
            },
            (error) => {
                dispatch(loadMessagesRequestFail(error));
                errorCallback && errorCallback(error);
            },
        );
    };
};

export const sendMessage = (chat_id, contentType, payload, callback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,

            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        let data = {
            chat_id,
            payload,
            content_type: contentType,
            profile_id: get(store.getState().Shops, 'currentShopAdministrator.profile.id'),
        };

        dispatch(sendMessageRequestStart(data));

        instance.post('/bot/messages/send_message/', data).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(sendMessageRequestSuccess(response.data.result));
                    callback && callback(response.data.result);
                } else {
                    toast.error(i18next.t('errors.common.request_sent_short', 'Error sending request!'));
                    dispatch(sendMessageRequestFail(response.data.errors));
                }
            },
            error => {
                toast.error(i18next.t('errors.common.request_sent_short', 'Error sending request!'));
                dispatch(sendMessageRequestFail(error));
            },
        );
    };
};


export const addContact = (name, phone) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,

            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        let data = {
            "shop_id": store.getState().Shops.activeShop.id,
            "phone": phone,
            name,
        };
        return instance.post('/bot/import_botuser/', data).then(response => {
            if (response.data.status === 'success') {
                toast.success(i18next.t('chats.modal_adding_new_contact.new_user_added', 'New user added'));
                dispatch(addingNewContactRequestSuccess(response.data.details))
                return {data: response.data, status: true};
            }
        }, error => {
            if (error.response.status === 400) {
                dispatch(addingNewContactRequestFail({
                    'common': error.response.data.errors
                }))

                return {
                    common: error.response.data.errors,
                    status: false
                };
            }
            dispatch(addingNewContactRequestFail({
                'common': i18next.t('errors.common.request_sent', 'Error sending request')
            }))

            return {
                common: i18next.t('errors.common.request_sent', 'Error sending request'),
                status: false
            };
        })
    }
};

export const loadImportNewContacts = (file) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,

            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
            },
        });

        let formData = new FormData();
        formData.append("shop_id", store.getState().Shops.activeShop.id);
        formData.append("name_1", file);

        instance.post('bot/csv_import_botusers/', formData).then(
            response => {
                response = response.data;
                if (response.status == 'success') {
                    if (response.count_created_users) {
                        toast.success(i18next.t('chats.modal_import_new_contacts.contacts_successfully_imported', 'Contacts successfully imported') + ": " + response.count_created_users);
                    }

                    if (response.phone_invalid) {
                        dispatch(importNewContactsRequestFail({
                            phone_invalid: i18next.t('chats.modal_import_new_contacts.contacts_have_not_been_added', 'Contacts have not been added') + ": " + Object.keys(response.phone_invalid).join(', ')
                        }));
                    } else {
                        dispatch(importNewContactsRequestSuccess());
                        dispatch(importNewContactsToggleModal(false));
                    }
                }

                if (response.status == 'not success') {
                    toast.error(i18next.t('chats.modal_import_new_contacts.contacts_were_not_imported', 'Contacts were not imported'));
                    dispatch(importNewContactsRequestFail());
                }
            },
            error => {
                error = error.response;
                if (!!error && error.status == 400) {
                    return dispatch(importNewContactsRequestFail({
                        'common': error.data.errors
                    }));
                }
                dispatch(importNewContactsRequestFail({
                    'common': i18next.t('errors.common.request_sent', 'Error sending request')
                }));
            }
        );
    };
};
